import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import VueI18n from "vue-i18n";
import Vuex from "vuex";
import NProgress from "nprogress";
import vSelect from "vue-select";

// load stimulus controllers
import "controllers/owner";

import VModal from "vue-js-modal";
import VTooltip from "v-tooltip";
import VeeValidate from "vee-validate";
import vuexStore from "../../owner/store";
import VueSimpleAccordion from "vue-simple-accordion";
import "vue-simple-accordion/dist/vue-simple-accordion.css";
import InvBindings from 'owner/inventories/button_bindings';
import InvRedeems from 'owner/voucher/button_redeems';

Vue.use(Vuex);
const store = new Vuex.Store(vuexStore());

import App from "owner/App.vue";

// CSS vendor
import "./styles.css";
import "vue-select/dist/vue-select.css";

require("shoelace-css/source/js/dropdowns.js");
require("matchmedia-polyfill/matchMedia");
require("matchmedia-polyfill/matchMedia.addListener");

const { $, Rollbar } = window;
const vMediaQuery = require("v-media-query/dist/v-media-query");

function initZendeskJs() {
  zE.setLocale(window.appConfig.locale);
  const restaurant = window.appConfig.restaurantIdentifier;
  const { currentOwner } = window.appConfig;
  zE.identify({
    organization: restaurant.name,
    name: currentOwner.name,
    email: currentOwner.email,
    user_type: currentOwner.type
  });
}

$(document).on("ajaxStart", event => {
  NProgress.set(0.4);
});

$(document).on("ajaxStop", () => {
  NProgress.done(true);
});

$(document).ready(() => {
  if ($("#app-container").length) {
    Vue.config.errorHandler = function errorHandlerF(error, vm, info) {
      console.error("Vue error", { error, vm, info });
      Rollbar.error("Vue error", { error, vm, info });
    };

    Vue.use(VModal, { dynamic: true });
    Vue.use(VTooltip);
    Vue.use(VeeValidate);
    Vue.use(vMediaQuery.default);
    Vue.use(VueI18n);
    Vue.component("v-select", vSelect);
    Vue.use(VueSimpleAccordion);

    const i18n = new VueI18n({
      locale: window.appConfig.locale,
      fallbackLocale: "en",
      silentTranslationWarn: true
    });
    Vue.mixin({
      computed: {
        isMobile() {
          return this.$mq.resize && this.$mq.below(640);
        },
        isDesktop() {
          return this.$mq.resize && this.$mq.above(639);
        }
      }
    });

    new Vue({
      i18n,
      store,
      render: h => h(App)
    }).$mount("#app-container");
  }

  if (typeof window.zE === "function") {
    window.zE(initZendeskJs);
  }

  let HW_config = {
    selector: ".headway",
    account: "yjv0Qy"
  };

  let { Headway } = window;
  if (typeof Headway === "undefined") {
    Headway = { init() { } };
  }
  Headway.init(HW_config);

  InvBindings();
  InvRedeems();
});
